/* import __COLOCATED_TEMPLATE__ from './analytics.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();